
/**
 *
 */
const style = (t) => {
    const { colors } = t['foundations-library']
    const colorsMap = {
        primary: colors.primary[50],
        neutral: colors.neutral[50]
    }
    return {
        tabs: {
            '&:not(.tabs--textual)': {
                overflow: 'hidden',
                borderRadius: '25px',
                backgroundColor: ({ color }) => colorsMap[color] || colors?.[color]?.[50],
                padding: '3px',
                display: 'flex',
                justifyContent: 'space-evenly',
                width: '100%'
            }
        }
    }
}

export default style
